<template>
  <transition name="spinner-transition" @after-leave="removeStyle">
    <div class="spinner-fade">
      <b-spinner class="spinner" :variant="variant" :style="spinnerStyle"/>
    </div>
  </transition>
</template>

<script>
export default {
  name: "SpinnerBackdrop",
  props: {
    size: {
      type: String,
      default: "3rem",
    },
    thickness: {
      type: String,
      default: "1em",
    },
    color: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "primary",
    },
  },
  data: function () {
    return {
      parent: null,
      lastStyle: "",
    };
  },
  computed: {
    spinnerStyle: function () {
      const style = {};
      style["color"] = this.color;
      style["width"] = this.size;
      style["height"] = this.size;
      style["border-width"] = this.thickness;
      return style;
    },
  },
  mounted () {
    this.parent = this.$el.parentElement;
    if (this.parent) {
      const compStyle = getComputedStyle(this.parent);
      if (compStyle.position === "static") {
        this.lastStyle = this.parent.style.position;
        this.parent.style.position = "relative";
      }
    }
  },
  methods: {
    removeStyle: function () {
      if (this.parent) {
        this.parent.style.position = this.lastStyle;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.spinner-fade {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: $zindex-modal-backdrop;
  background-color: rgba(#fff, 0.7);
  transition: opacity 0.2s;
}

.spinner-transition-enter, .spinner-transition-leave-to {
  opacity: 0;
}

.spinner-transition-enter-to, .spinner-transition-leave {
  opacity: 0.7;
}
</style>